<template>
  <div class="conversation-hub-container">
    <ConversationTabs
      v-if="displayTabs"
      :active-tab="activeTab"
      :conversation-hub="conversationHub"
      @tab-change="setActiveTab" />
    <!-- Tab Conversation -->
    <div v-if="isConversationsTab" class="conversations-list">
      <ConversationCard
        v-for="(conv, idx) in conversations"
        :key="idx"
        :conversation="conv"
        :index="idx"
        :avatar="avatar"
        :assistant-title="assistantTitle"
        @click="$emit('conversation-click', conv)" />
    </div>
    <!-- Tab Information -->
    <div v-else class="info-tab">
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div v-if="sanitizedContent" @click="checkClick" v-html="sanitizedContent"></div>
    </div>
    <div v-if="displayTabs" class="resume-btn-container">
      <button class="resume-btn" @click="$emit('resume-conversation')">
        {{ $t('conversation_hub.resume_conversation_button') }}
      </button>
    </div>
  </div>
</template>

<script>
// Components
import ConversationCard from './ConversationCard.vue'
import ConversationTabs from './ConversationTabs.vue'

// Style
import '../../assets/styles/conversationHub.css'

// Configs
import hubConfig from '../../config/conversationHub.js'
import config from '../../config/index.js'

// Dependencies
import { mapGetters } from 'vuex'

// libs
import { sendMessage } from '../../lib/chipMessage'

export default {
  name: 'ConversationHub',
  components: { ConversationCard, ConversationTabs },
  props: {
    conversationHub: {
      type: Object,
      default: () => ({})
    },
    avatar: {
      type: String,
      required: true
    },
    assistantTitle: {
      type: String,
      required: true
    },
    // In hamburger mode, we display tabs from the Conversation Hub component
    // while in tab mode, they are displayed in the parent component
    displayTabs: {
      type: Boolean,
      default: true
    },
    isKiosk: { type: Boolean, required: true },
    assistantId: { type: String, required: true }
  },
  data() {
    return {
      activeTab: hubConfig.TABS.INFORMATION,
      tabs: hubConfig.TABS
    }
  },
  computed: {
    ...mapGetters(['conversations', 'selectedHubTab']),
    hubInformation() {
      return (this.conversationHub && this.conversationHub.information) || {}
    },
    sanitizedContent() {
      if (this.hubInformation.htmlContent) {
        return this.$sanitize(this.hubInformation.htmlContent)
      }
      return null
    },
    isConversationsTab() {
      return this.activeTab === hubConfig.TABS.CONVERSATIONS
    }
  },
  watch: {
    selectedHubTab(newVal) {
      this.activeTab = newVal
    }
  },
  mounted() {
    this.activeTab = this.selectedHubTab
  },
  methods: {
    setActiveTab(tab) {
      this.activeTab = tab
      this.$store.dispatch('set_selected_hub_tab', tab)
    },
    parsePayload(payload) {
      if (!payload) {
        return undefined
      }

      try {
        const preparedPayload = payload.replace(/'/g, '"')
        return JSON.parse(preparedPayload)
      } catch (error) {
        return payload
      }
    },
    checkClick(event) {
      if (!event || !event.target) {
        return
      }

      if (event.target.href) {
        this.sendMessage('', { url: event.target.href })
      }

      if (!event.target.dataset) {
        return
      }

      const clickType = event.target.dataset
      const parsedPayload = this.parsePayload(clickType[hubConfig.SEND_MESSAGE_PROPERTIES.PAYLOAD])
      if (clickType[hubConfig.SEND_MESSAGE_PROPERTIES.MAIN_CONTENT] || parsedPayload) {
        this.sendMessage(clickType[hubConfig.SEND_MESSAGE_PROPERTIES.MAIN_CONTENT], parsedPayload)
        this.$emit('resume-conversation')
      }
    },
    sendMessage(mainContent, payload) {
      sendMessage(
        this.$store,
        payload,
        mainContent,
        config.SOURCE_TYPES.HUB,
        this.assistantId,
        this.$t('location_permission_error'),
        mainContent ? config.EVENT_ELEMENTS.HUB_MESSAGE : config.EVENT_ELEMENTS.HUB_LINK,
        this.isKiosk
      )
    }
  }
}
</script>
